import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './chemistry.component.html',
	styleUrls: ['./chemistry.component.css']
})

export class ChemistryComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/chemistry.component.ts